import { render, staticRenderFns } from "./quotationMaterial-tab.vue?vue&type=template&id=6970a00c"
import script from "./quotationMaterial-tab.vue?vue&type=script&lang=js"
export * from "./quotationMaterial-tab.vue?vue&type=script&lang=js"
import style0 from "./quotationMaterial-tab.vue?vue&type=style&index=0&id=6970a00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports